<template>
	<div class="tab">
		<div
			class="tab-item"
			:class="selectedTab == 'users' ? 'active' : ''"
			@click="handleTab('users')"
		>
			<span>Usuários</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'InvestorTab',
	data: () => ({
		selectedTab: 'users',
	}),
	methods: {
		handleTab(param) {
			this.selectedTab = param;
			this.$emit('handleTab', param);
		},
	},
};
</script>

<style lang="scss">
@import 'InvestorTab.scss';
</style>
